export const styleConstants = {
  colorBackgroundWhite: "#FFFFFF",
  colorBackgroundLight: "#fbf2f6",
  colorBackgroundLightDark: "#F6E5EE",
  colorBackgroundLightDarker: "#E9BFD3",
  colorBackgroundTheme: "#A80051",
  colorBackgroundThemeSoft: "#B82E70",
  colorBackgroundDarkLighter: "#970049",
  colorBackgroundDarkLight: "#860041",
  colorBackgroundDark: "#220010",
  colorBackgroundBlack: "#000000",

  colorBackgroundDanger: "#DE1C22",
  colorBackgroundWarning: "#E86825",
  colorBackgroundSuccess: "#008556",
  colorBackgroundGray: "#C7C7C7",
  colorBackgroundDisabled: "#E4E4E4",
  colorBackgroundBackdrop: "rgba(0,0,0,0.3)",
  colorBackgroundBackdropWhite: "rgba(251, 242, 246, 0.60)",

  colorTextDark: "rgba(34, 0, 16, 0.92)",
  colorTextDarkSoft: "rgba(34, 0, 16, 0.85)",
  colorTextDarkSofter: "rgba(34, 0, 16, 0.7)",

  colorTextLight: "#FBF2F6",
  colorTextLightSoft: "rgba(251, 242, 246, 0.72)",
  colorTextLightSofter: "rgba(251, 242, 246, 0.4)",

  colorTextTheme: "#A80051",
  colorTextDanger: "#DE1C22",
  colorTextSuccess: "#008556",
  colorTextWarning: "#E86825",
  colorTextDisabled: "#C7C7C7",

  spacingExtraSmall: 4,
  spacingSmall: 8,
  spacingMedium: 12,
  spacingLarge: 16,
  spacingExtraLarge: 24,

  fontSizeExtraSmall: 12,
  fontSizeSmall: 14,
  fontSizeMedium: 16,
  fontSizeLarge: 20,
  fontSizeExtraLarge: 24,

  borderRadiusSmall: 4,
  borderRadiusMedium: 8,
  borderRadiusLarge: 16,
};
